<div class="relative block mx-auto max-w-[1366px] px-2.5">
  <ng-content/>
</div>
